
<template>
  <div>
     <!-- 예약리스트 모달 부분  -->
    <div
      class="admin_addModalBox"
      :class="modalListStatus ? '' : 'display_none'"
    >
      <div class="admin_addModalBox_dim">
      </div>
      <div class="admin_addModalBox_inner_big admin_addModalBox_inner_scheduleList">
        <div class="admin_addModalBox_tit">
          <p>예약리스트</p>
          <button
            class="admin_addModalBox_BtnClose"
            v-on:click="modal_close"
          >
          </button>
        </div>

        <div class="admin_addModalBox_search admin_addModalBox_search_scheduleList">
          <input
            type='text'
            id = 'search_list_data'
            name = 'search_list_data'
            maxLength="30"
            placeholder = "탑승자명 또는 휴대폰번호를 입력해주세요."
            v-model="searchListData"
          />
          <button v-on:click="seat_list_search">검색</button>
          <button @click="downloadExcel">엑셀 다운로드</button>
          <button v-on:click="send_sns">문자발송</button>
          <button v-on:click="add_list">리스트추가</button>
        </div>

        <div class="admin_addModalBox_result admin_addModalBox_result_scheduleList">
          <!-- 데이터가 없을 시  -->
          <div
            class="admin_addModalBox_result_noData"
            v-if="this.listData.length === 0">
            <p>예약고객이 없습니다.</p>
          </div>

          <!-- 데이터가 있을시 시  -->
          <div
            class="admin_addModalBox_result_Data admin_addModalBox_result_Data_big admin_addModalBox_result_Data_scheduleList"
            v-else
            >
            <p class="mgb10">
              * 예약ID는 결제현황 메뉴에 있는 ID입니다. <br/>
              * 회색 테두리는 직접 작성하여 변경 가능합니다.
            </p>

            <ul class="admin_addModalBox_result_Data_ulTit_big admin_addModalBox_result_Data_ul_scheduleList">
              <li>결제여부</li>
              <li>예약ID</li>
              <li>예약좌석</li>
              <li>탑승자명</li>
              <li>휴대폰번호</li>
              <li>생년월일</li>
              <li>성별</li>
              <li>탑승지</li>
              <li>상태</li>
              <li>기능</li>
            </ul>

            <ul class="admin_addModalBox_result_Data_ulInfo_big admin_addModalBox_result_Data_ul_scheduleList"
              v-for="item in listData"
              :key="item.reservation_seat_ID"
              >
              <li>
                {{item.reservation_pay_status}}
              </li>
              <li>
                {{item.reservation_ID_use_reservation_seat}}
              </li>
              <li>
                <input
                  type="text"
                  v-model="item.reservation_seat_name"
                  maxlength="12"
                  placeholder="예약좌석 입력"
                />
              </li>
              <li>
                <input
                  type="text"
                  v-model="item.reservation_seat_customer_name"
                  maxlength="12"
                  placeholder="탑승자명 입력"
                />
              </li>
              <li>
                <input
                  type="tel"
                  v-model="item.reservation_seat_customer_phone_number"
                  placeholder="휴대폰번호 입력"
                  maxlength="13"
                  pattern="[0-9]{3}-[0-9]{3,4}-[0-9]{4}"
                />
              </li>
              <li>
                <input
                  type="date"
                  class="admin_addModalBox_result_Data_ulTit_bigDate"
                  v-model="item.reservation_seat_customer_birthday"
                />
              </li>
              <li>
                <select
                  v-model="item.reservation_seat_customer_gender"
                >
                  <option value="1">남</option>
                  <option value="2">여</option>
                </select>
              </li>
              <li>
                <input
                  type="text"
                  class="admin_addModalBox_result_Data_li_text"
                  v-model="item.reservation_seat_departure_station"
                  placeholder="탑승지 입력"
                  maxlength="13"
                />
              </li>
              <li>
                {{item.change_status}}
              </li>
              <li class="admin_addModalBox_result_Data_li_btn_big">
                <button
                  v-on:click="modifyReservation(item)"
                >
                  변경
                </button>
                <button v-if="item.reservation_ID_use_reservation_seat === 0"
                  v-on:click="deleteReservation(item)"
                >
                  샥제
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div> <!-- 예약리스트 모달 부분  -->

    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'4-3'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>여행 관리 - 여행일정 관리</p>
          <div class="Admin_PageHeader_btn">
            <router-link to="/AdminScheduleManagementAdd" class="Admin_PageHeader_btn01">등록</router-link>
            <button class="Admin_PageHeader_btn02" v-on:click="edit">수정</button>
            <button class="Admin_PageHeader_btn03" v-on:click="copy_row">복제하기</button>
            <!-- <button class="Admin_PageHeader_btn03" v-on:click="delete_row">삭제</button> -->
          </div>
        </div>

        <div class="Admin_PageInner">
          <div class="Admin_PageInfo">
            <p>사용 방법 안내</p>
            <p>1. 삭제는 안되며 수정 버튼을 통해 사용 여부를 미사용으로 활용하면 됩니다.</p>
          </div>
          <button @click="toggleSearchPanel" class="Admin_toggleSearch_openBtn">
            검색
          </button>
          <div class="Admin_toggleSearchWrap" v-if="isPanelVisible">
            <div class="Admin_toggleSearcTit">
              <p>검색조건</p>
              <button class="Admin_toggleSearch_closeBtn" @click="toggleSearchPanel"></button>
            </div>
            <div class="Admin_toggleSearcBox">
              <label for="TravelTypeDivision">여행타입 구분</label>
              <select id="TravelTypeDivision" v-model="selectTravelTypeDivision">
                <option value=''>선택하세요.</option>
                <option value='1'>국악와인열차</option>
                <option value='2'>팔도장터열차</option>
                <option value='3'>일반기차여행</option>
                <option value='4'>버스/자유여행</option>
                <option value='5'>섬/제주/해외여행</option>
              </select>
            </div>
            <div class="Admin_toggleSearcBox">
              <label for="travelProductName">여행상품명</label>
              <input
                  type='text'
                  id="travelProductName"
                  placeholder = "여행상품명을 입력해주세요."
                  v-model="travelProductName"
                  @keydown.enter="fetchDataWithParams"
                />
            </div>
            <button @click="fetchDataWithParams" class="Admin_toggleSearch_searchBtn">검색</button>
          </div>
          <div ref="table"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import {TabulatorFull as Tabulator} from 'tabulator-tables'
import {
  get_schedule,
  copy_schedule,
  get_reservation_seat_list,
  update_reservation_seat,
  add_reservation_seat_list,
  delete_reservation_seat
} from '../../ETC/Axios.vue'
import * as XLSX from 'xlsx'

export default {
  name: 'AdminScheduleManagement',
  components: {
    AdminHeader,
    AdminFooter
  },
  data () {
    return {
      tabulator: null,
      isPanelVisible: false,
      selectTravelTypeDivision: '',
      travelProductName: '',
      modalListStatus: false,
      modalSeatStatus: false,
      listData: [],
      seatData: [],
      searchListData: '',
      clickScheduleID: ''
    }
  },
  methods: {
    downloadExcel () {
      const data = this.listData.map(item => ({
        결제여부: item.reservation_pay_status,
        예약ID: item.reservation_ID_use_reservation_seat,
        예약좌석: item.reservation_seat_name,
        탑승자명: item.reservation_seat_customer_name,
        휴대폰번호: item.reservation_seat_customer_phone_number,
        생년월일: item.reservation_seat_customer_birthday,
        성별: (item.reservation_seat_customer_gender === '1' || item.reservation_seat_customer_gender === 1) ? '남' : '여',
        탑승지: item.reservation_seat_departure_station
      }))

      const ws = XLSX.utils.json_to_sheet(data)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, '예약리스트')

      XLSX.writeFile(wb, '예약리스트.xlsx')
    },
    modifyReservation: function (list) {
      update_reservation_seat(
        list.reservation_seat_ID,
        list.reservation_seat_customer_birthday,
        list.reservation_seat_customer_gender,
        list.reservation_seat_customer_name,
        list.reservation_seat_customer_phone_number,
        list.reservation_seat_departure_station,
        list.reservation_seat_name
      ).then(result_data => {
        list.change_status = '변경완료'
      })
    },
    deleteReservation: function (list) {
      if (confirm('정말 삭제하시겠습니까?')) {
        delete_reservation_seat(
          list.reservation_seat_ID,
          list.reservation_number_ID_use_reservation_seat
        ).then(result_data => {
          this.listData = this.listData.filter(item => item.reservation_seat_ID !== list.reservation_seat_ID)
          let updatedData = this.tabulator.getData().map(item => {
            if (item.schedule_ID === this.clickScheduleID) {
              item.total_reservation_number_count -= 1
            }
            return item
          })

          this.tabulator.replaceData(updatedData)
        }).catch(error => {
          console.error('삭제 중 오류가 발생했습니다:', error)
        })
      }
    },
    seat_list_search: function () {
      get_reservation_seat_list(
        this.clickScheduleID,
        this.searchListData
      ).then(result_data => {
        this.listData = result_data
        let updatedData = this.tabulator.getData().map(item => {
          if (item.schedule_ID === this.clickScheduleID) {
            item.total_reservation_number_count = this.listData.length
          }
          return item
        })
        this.tabulator.replaceData(updatedData)
      })
    },
    modal_close: function () {
      this.modalListStatus = false
      this.modalSeatStatus = false
    },
    add_list: function () {
      add_reservation_seat_list(this.clickScheduleID).then(result_data => {
        const newItem = {
          reservation_seat_ID: result_data.reservation_seat_ID,
          reservation_number_ID_use_reservation_seat: result_data.reservation_number_ID,
          reservation_pay_status: '관리자 추가',
          reservation_ID_use_reservation_seat: 0,
          reservation_seat_name: '',
          reservation_seat_customer_name: '',
          reservation_seat_customer_phone_number: '',
          reservation_seat_customer_birthday: '',
          reservation_seat_customer_gender: '1',
          reservation_seat_departure_station: '',
          change_status: '변경 클릭 전'
        }
        this.listData.unshift(newItem)

        let updatedData = this.tabulator.getData().map(item => {
          if (item.schedule_ID === this.clickScheduleID) {
            item.total_reservation_number_count += 1
          }
          return item
        })

        this.tabulator.replaceData(updatedData)
      })
    },
    send_sns: function () {
      const phoneNumbers = this.listData
        .map(item => item.reservation_seat_customer_phone_number)
        .filter(num => num)
      if (phoneNumbers.length === 0) {
        alert('발송할 고객 번호가 없습니다.')
        return
      }
      const formattedNumbers = phoneNumbers.map(num => num.replace(/-/g, ''))
      const phoneQuery = encodeURIComponent(formattedNumbers.join(','))
      window.location.href = `/AdminSendMessage?phoneNumbers=${phoneQuery}`
    },
    edit: function () {
      if (this.tabulator.getSelectedData().length > 1) {
        alert('수정할 데이터를 하나만 선택해주세요.')
      } else if (this.tabulator.getSelectedData().length === 0) {
        alert('수정할 데이터를 선택해주세요.')
      } else {
        window.location.href = `/AdminScheduleManagementAdd?schedule_ID=${this.tabulator.getSelectedData()[0].schedule_ID}`
      }
    },
    toggleSearchPanel: function () {
      this.isPanelVisible = !this.isPanelVisible
    },
    fetchDataWithParams: function () {
      const params = {
        travel_type_division: this.selectTravelTypeDivision,
        travel_product_name: this.travelProductName
      }
      get_schedule(params).then(result_data => {
        this.tabulator.setData(result_data)
        this.tabulator.setPage(1)
      })
    },
    copy_row: function () {
      let temp_copy_array = []
      if (this.tabulator.getSelectedData().length === 0) {
        alert('복제할 리스트를 선택해주세요.')
      } else {
        this.tabulator.getSelectedData().forEach((element) => {
          temp_copy_array.push(element.schedule_ID)
        })
        copy_schedule(JSON.stringify(temp_copy_array)).then((result) => {
          if (result === undefined) {
            alert('복제가 되지 않았습니다. 관리자한테 확인해주세요.')
          } else {
            alert('복제가 완료 되었습니다.')
            window.location.reload()
          }
        })
      }
    }
  },
  mounted () {
    const params = {
      travel_type_division: this.selectTravelTypeDivision,
      travel_product_name: this.travelProductName
    }
    const self = this
    get_schedule(params).then(result_data => {
      this.tabulator = new Tabulator(this.$refs.table, {
        data: result_data,
        layout: 'fitData',
        movableRows: true,
        pagination: 'local',
        paginationSize: 100,
        paginationButtonCount: 5,
        columns: [
          {formatter: 'rowSelection',
            titleFormatter: 'rowSelection',
            headerSort: false,
            cellClick: function (e, cell) {
              cell.getRow().toggleSelect()
            }
          },
          {title: '일정ID', field: 'schedule_ID', headerSort: false},
          {title: '여행타입 구분', field: 'travel_type_division', headerSort: false},
          {title: '여행타입명', field: 'travel_type_name', headerSort: false},
          {title: '여행상품명', field: 'travel_product_name', headerSort: false},
          {title: '여행기간', field: 'travel_period', headerSort: false},
          {
            title: '최소출발인원',
            field: 'travel_product_minimum_departure',
            headerSort: false,
            formatter: function (cell, formatterParams, onRendered) {
              return cell.getValue() + '명'
            }
          },
          {title: '출발일', field: 'schedule_start_day', headerSort: false},
          {title: '종료일', field: 'schedule_end_day', headerSort: false},
          {title: '총 좌석수', field: 'total_schedule_seats', headerSort: false},
          {title: '총 예약수', field: 'total_reservation_number_count', headerSort: false},
          {
            title: '예약리스트',
            field: 'schedule_status',
            headerSort: false,
            formatter: function (cell, formatterParams, onRendered) {
              return '<button class="pointTextBlue">확인하기</button>'
            },
            cellClick: function (e, cell) {
              self.modalListStatus = true
              self.clickScheduleID = cell.getRow().getData().schedule_ID
              get_reservation_seat_list(
                cell.getRow().getData().schedule_ID,
                ''
              ).then(result_data => {
                self.listData = result_data
              })
            }
          },
          {
            title: '좌석배치도',
            field: 'schedule_status',
            headerSort: false,
            formatter: function (cell, formatterParams, onRendered) {
              return '<button class="pointTextBlue">확인하기</button>'
            },
            cellClick: function (e, cell) {
              alert('좌석배치도는 준비 중이에요 :)')
            }
          },
          {title: '옵션사용여부', field: 'schedule_option_use_status', headerSort: false},
          {title: '사용여부', field: 'schedule_status', headerSort: false},
          {title: '등록 일자', field: 'schedule_registe', headerSort: false},
          {title: '수정 일자', field: 'schedule_modified', headerSort: false}
        ]
      })
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/TravelManagement/AdminScheduleManagement.vue